import { TextField, InputLabel, Button, Box } from '@mui/material';

const TextFieldComponent = (props) => {
  const { label, placeholder, endAdornment, register } = props
  return (
    <TextField
      className='w-100 text-field'
      {...register}
      {...props}
      placeholder={placeholder}
      label={label}
      variant="outlined"
      InputLabelProps={{
        style: { color: 'white' },
        className: 'textfeild_white'
      }}
      InputProps={{
        className: 'textfeild_white',
        endAdornment: endAdornment
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: '#cdcdcd',
          },
          '&:hover fieldset': {
            borderColor: 'white',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'white',
          },
        },
        '& .MuiInputLabel-root': {
          color: 'white !important',
        },
        '& .MuiInputLabel-shrink': {
          color: 'white !important',
        },
        '&:-webkit-autofill': {
          '-webkit-box-shadow': '0 0 0px 1000px transparent inset',
          '-webkit-text-fill-color': '#fff',
        },
        '& input::placeholder': {
          color: 'white !important',
        },
        '& input::-webkit-input-placeholder': {
          color: 'white !important',
        },
        '& input::-moz-placeholder': {
          color: 'white !important',
        },
        '& .MuiOutlinedInput-input': {
          color: 'white',
        },
      }}
    />
  )
}

export default TextFieldComponent;